<template>
  <div class="pDetail" v-loading="isLoading">
    <div class="pControl flex-row flex__between">
      <div class="pAddShape flex-row flex__left">
        <canvas-tool-button
          :label="'Xoá'"
          :iconClass="'fas fa-trash font-size__medium color__red '"
          @click="deleteShape"
          :disabled="!selectedShape"
        >
        </canvas-tool-button>
        <canvas-font-size
          @fontSizeChanged="setFontSize"
          :disabled="!isFontSizeChangable"
        ></canvas-font-size>
        <canvas-buttons-group
          :disabled="!isFontSizeChangable"
          @alignChanged="setAlign"
          :buttonConfigs="alignmentButtonConfigs"
        ></canvas-buttons-group>
        <canvas-buttons-group
          :disabled="!isFontSizeChangable"
          @alignChanged="setFontStyle"
          :buttonConfigs="fontStyleButtonConfigs"
        ></canvas-buttons-group>
      </div>
    </div>

    <transition name="el-fade-in-linear">
      <VuePerfectScrollbar :class="['pScrollDoc transition-box page-center']">
        <div ref="canvasContainer"></div>
        <!-- @drop="ondrop($event)"
          @dragenter.prevent
          @dragover.prevent
          @click="handleClick($event)" -->
      </VuePerfectScrollbar>
    </transition>

    <edit-phu-luc-dialog
      ref="editPhuLucDialog"
      :isOpen="isOpenEditPhuLucDialog"
      v-if="isEnableEditPhuLucDialog"
      @closed="isEnableEditPhuLucDialog = false"
      @closeDialog="isOpenEditPhuLucDialog = false"
    >
    </edit-phu-luc-dialog>
  </div>
</template>

<script>
import Konva from "konva";
import uuidv4 from "uuid/v4";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../../constants";
import h from "../../../services/h";
import CanvasButtonsGroup from "./canvas-buttons-group";
import CanvasFontSize from "./canvas-font-size";
import CanvasToolButton from "./canvas-tool-button";
import EditPhuLucDialog from "./edit-phu-luc-dialog";
import dateUtils from "../../../dateUtils";

export default {
  name: "detail-docs-v2",
  props: ["isLoading"],

  components: {
    EditPhuLucDialog,
    CanvasButtonsGroup,
    CanvasFontSize,
    CanvasToolButton,
    VuePerfectScrollbar
  },

  computed: {
    isDrawing() {
      return !!this.action;
    },
    isFontSizeChangable() {
      return this.selectedShape && this.selectedShape.className === "Text";
    }
  },

  data() {
    return {
      stage: null,
      backgroundLayer: null,
      backgroundImage: null,
      drawLayer: null,
      backgroundURL: null,
      scale: 1,
      scaleImageX: 1,
      scaleImageY: 1,
      action: null,
      isDrawing1: false,
      startPointerPosition: null,
      shapeOptions: null,
      drawingShape: null,
      transformer: null,
      selectedShape: null,
      textNodeBackgroundShapeRelations: [],
      shapeOptionsData: [],
      alignmentButtonConfigs: [
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.LEFT,
          label: "Căn trái",
          iconClass: "fas fa-align-left"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.CENTER,
          label: "Căn trái",
          iconClass: "fas fa-align-center"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.RIGHT,
          label: "Căn trái",
          iconClass: "fas fa-align-right"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.ALIGN.JUSTIFY,
          label: "Dàn đều",
          iconClass: "fas fa-align-justify"
        }
      ],
      fontStyleButtonConfigs: [
        {
          value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.NORMAL,
          label: "Bình thường",
          iconClass: "fas fa-ad"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.BOLD,
          label: "Đậm",
          iconClass: "fas fa-bold"
        },
        {
          value: constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC,
          label: "Nghiêng",
          iconClass: "fas fa-italic"
        }
      ],
      isOpenEditPhuLucDialog: false,
      isEnableEditPhuLucDialog: false
    };
  },

  watch: {
    isOpenEditPhuLucDialog(newValue) {
      newValue && (this.isEnableEditPhuLucDialog = newValue);
    }
  },

  mounted() {
    this.initCanvas();
  },

  methods: {
    isPageModified() {
      return !!(this.drawLayer.children && this.drawLayer.children.length);
    },

    toImagePromise(shape, config) {
      return new Promise((resolve, reject) => {
        config.callback = image => {
          resolve(image);
        };
        shape.toImage(config);
      });
    },

    merge2ImagesToBase64(image, textBackgroundImage) {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let backgroundWidth = (canvas.width = textBackgroundImage.width);
      let backgroundHeight = (canvas.height = textBackgroundImage.height);
      // context.globalAlpha = 0;
      context.drawImage(textBackgroundImage, 0, 0);
      context.globalAlpha = 1; //Remove if pngs have alpha
      let imageWidth = image.width;
      let imageHeight = image.height;
      context.drawImage(
        image,
        (backgroundWidth - imageWidth) / 2,
        (backgroundHeight - imageHeight) / 2
      );
      return canvas.toDataURL("image/png");
    },

    convertImageToBase64(image1) {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      canvas.width = image1.width;
      canvas.height = image1.height;
      context.globalAlpha = 1.0;
      context.drawImage(image1, 0, 0);
      return canvas.toDataURL("image/png");
    },

    toBase64Promise(shape, config) {
      return this.toImagePromise(shape, config).then(image => {
        let className = shape.className;
        if (className !== "Text") return this.convertImageToBase64(image);
        let textBackgroundShape = this.findTextNodeBackgroundShape(shape.id());
        if (!textBackgroundShape) return this.convertImageToBase64(image);
        return this.toImagePromise(
          textBackgroundShape,
          config
        ).then(textBackgroundImage =>
          this.merge2ImagesToBase64(image, textBackgroundImage)
        );
      });
    },

    getPageImageData() {
      let pixelRatio = 1 / this.scale;
      let pageSize = this.backgroundImage.size();

      //loai bo textNodeBackground;
      let shapes = h.findAll(this.drawLayer.getChildren(), shape => {
        let shapeOptions = this.findShapeOptionsByShapeId(shape.id());
        return shapeOptions && shapeOptions.shapeType;
      });

      let isGroup = false;

      return Promise.all(
        h.collect(shapes, shape => {
          // Điều chỉnh độ phân giản của ảnh
          let toImageConfig = {pixelRatio: 4};

          return this.toBase64Promise(shape, toImageConfig).then(base64 => {
            return {shape: shape, base64: base64};
          });
        })
      ).then(imageResults => {

        return {
          size: {
            width: pageSize.width,
            height: pageSize.height
          },
          pageImage: this.stage.toDataURL({pixelRatio: pixelRatio}),
          shapeImages: h.collect(imageResults, imageResult => {
            let shape = imageResult.shape;

            if (isGroup) {
              shape.scaleX(this.scaleImageX);
              shape.scaleY(this.scaleImageY);
            }

            let base64 = imageResult.base64;

            let shapeSize = shape.size();

            shapeSize = {
              width: shapeSize.width * shape.scaleX(),
              height: shapeSize.height * shape.scaleY()
            };

            let shapeOptions = this.findShapeOptionsByShapeId(shape.id());
            let shapePosition = this.calculatorShapePosition(shape);

            if (shapeOptions.addWhiteBackground) {
              //neu add them background > co margin > can tinh toan lai size & postion
              shapePosition = {
                x: shapePosition.x - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
                y: shapePosition.y - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN
              };
              shapeSize = {
                width:
                  shapeSize.width + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2,
                height:
                  shapeSize.height + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2
              };
            }
            return {
              uri: base64,
              shapeId: shape.id(),
              position: {
                x: shapePosition.x * pixelRatio,
                y: shapePosition.y * pixelRatio
              },
              size: {
                width: shapeSize.width * pixelRatio,
                height: shapeSize.height * pixelRatio
              },
              shapeType: shapeOptions ? shapeOptions.shapeType : null,
              comment: shape.className === "Text" ? shape.text() : null
            };
          })
        };
      });
    },

    calculatorShapePosition(shape) {
      if (shape.parent.getClassName() === "Group") {
        return {
          x: shape.getAbsolutePosition().x,
          y: shape.getAbsolutePosition().y
        };
      }

      return shape.position();
    },

    getPageData() {
      return {
        stage: JSON.parse(this.stage.toJSON()),
        textNodeBackgroundShapeRelations: this.textNodeBackgroundShapeRelations,
        shapeOptionsData: this.shapeOptionsData
      };
    },

    deleteShape() {
      if (this.transformer) {
        this.transformer.destroy();
        this.transformer = null;
      }
      if (this.selectedShape) {
        if (this.selectedShape.getType() === "Group") {
          // xoá ảnh chữ ký
          let shapeImage = this.selectedShape.findOne("Image");
          this.removeShapeOptionsByShapeId(shapeImage.id());
        }
        this.removeShapeOptionsByShapeId(this.selectedShape.id());
        if (this.selectedShape.className === "Text")
          this.deleteTextNodeBackgroundShape(this.selectedShape.id());
        this.selectedShape.destroy();
        this.selectedShape = null;
      }
      this.drawLayer.draw();
      this.isDrawing1 = false;
    },

    findTextNodeBackgroundShape(textNodeId) {
      let textNodeBackgroundShapeRelation = h.find(
        this.textNodeBackgroundShapeRelations,
        item => item.textNodeId === textNodeId
      );
      if (!textNodeBackgroundShapeRelation) return null;
      let textNodeBackgroundShapeId =
        textNodeBackgroundShapeRelation.textBackgroundShapeId;
      return this.drawLayer.find("#" + textNodeBackgroundShapeId)[0];
    },

    deleteTextNodeBackgroundShape(textNodeId) {
      let textNodeBackgroundShapeRelation = h.find(
        this.textNodeBackgroundShapeRelations,
        item => item.textNodeId === textNodeId
      );
      if (textNodeBackgroundShapeRelation) {
        let textNodeBackgroundShapeId =
          textNodeBackgroundShapeRelation.textBackgroundShapeId;
        let textBackgroundShape = this.drawLayer.find(
          "#" + textNodeBackgroundShapeId
        )[0];
        if (textBackgroundShape) textBackgroundShape.destroy();
        this.textNodeBackgroundShapeRelations.splice(
          this.textNodeBackgroundShapeRelations.indexOf(
            textNodeBackgroundShapeRelation
          ),
          1
        );
      }
    },

    setFontSize(fontSize) {
      this.selectedShape.fontSize(fontSize);
      this.drawLayer.draw();
    },

    setAlign(align) {
      this.selectedShape.align(align);
      this.drawLayer.draw();
    },

    setFontStyle(fontStyle) {
      this.selectedShape.fontStyle(fontStyle);
      this.drawLayer.draw();
    },

    initCanvas() {
      this.stage = new Konva.Stage({container: this.$refs.canvasContainer});
      this.stage.add(
        (this.backgroundLayer = new Konva.Layer({name: "backgroundLayer"}))
      );
      this.stage.add(
        (this.drawLayer = new Konva.Layer({
          name: constants.DETAIL_DOCS_PAGE.DRAW_LAYER_NAME
        }))
      );

      let konvaContent = this.$refs.canvasContainer.querySelector(
        ".konvajs-content"
      );
      konvaContent.style.position = "absolute";
      konvaContent.style.top = 0;
      konvaContent.style.left = 0;

      this.initAction();
    },


    initAction() {
      var con = this.stage.container();
      con.addEventListener("dragover", e => {
        e.preventDefault(); // !important
      });

      con.addEventListener("drop", e => {
        e.preventDefault();
        this.stage.setPointersPositions(e);
        if (this.isDrawing) this.startDrawing();
        this.endDrawing();
        // console.log("drop")
      });

      this.stage.on("mousedown", () => {
        if (this.isDrawing) this.startDrawing();
        this.endDrawing();
        // console.log("mousedown")
      });
      this.stage.on("mousemove", () => {
        if (this.isDrawing) this.dragDrawing();
        // console.log("mousemove")
      });
      this.stage.on("mouseup", () => {
        if (this.isDrawing) this.endDrawing();
        // console.log("mouseup")
      });
      this.stage.on("click", event => {
        if (event.target === this.backgroundImage) {
          this.removeTransformer_();
          this.drawLayer.draw();
          // console.log("click")
        }
      });
    },

    setDraggableForAllShapes(draggable) {
      h.each(this.drawLayer.children, child => {
        if (child.className === "Text") {
          let matches = child.text().match(/Ký bởi: (.+?)\nNgày Ký: (.+) GMT\+7/);
          if (matches) {
            child.text(`Ký bởi: ${matches[1]}\nNgày Ký: ${dateUtils.toMoment(new Date()).format("DD/MM/YYYY HH:mm:ss")} GMT+7`)
          }
        }
        child.draggable(draggable)
      });
      this.drawLayer.draw();
    },

    startDrawing() {
      this.setDraggableForAllShapes(false); // tranh truong hop chen anh moi tai vi tri thuoc anh cu > se bi nham lan;
      let pos = this.stage.getPointerPosition();

      let absolutePosition = this.stage.absolutePosition();

      let shape;
      this.startPointerPosition = [
        pos.x - absolutePosition.x,
        pos.y - absolutePosition.y
      ];
      let promise;
      switch (this.action) {
        case constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT:
          shape = this.drawShapeText(this.shapeOptions);
          this.initForShapeText(shape, this.shapeOptions);
          this.initActionForShapeText(shape, this.shapeOptions);
          promise = Promise.resolve(shape);
          break;
        case constants.DETAIL_DOCS_PAGE.ACTION.ADD_IMAGE:
          promise = this.drawShapeImage(this.shapeOptions);
          break;

        case constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT_AND_IMAGE:
          let fullNameShape = this.drawShapeText(this.shapeOptions.fullNameShape);
          let signDateShape = this.drawShapeText(this.shapeOptions.signDateShape);
          let imagePromise = this.drawShapeImage(this.shapeOptions.imageShape);

          promise = imagePromise.then(imageShape => {
            let group = new Konva.Group({
              id: uuidv4(),
              x: this.startPointerPosition[0],
              y: this.startPointerPosition[1],
              draggable: true
            });

            group.add(fullNameShape);
            group.add(signDateShape);
            group.add(imageShape);

            const boundingBox = group.getClientRect({relativeTo: group});
            group.width(boundingBox.width);
            group.height(boundingBox.height);

            return group;
          });
          break;
      }
      promise.then(shape => {
        this.shapeOptionsData.push({
          shapeId: shape.id(),
          shapeOptions: this.shapeOptions
        });
        this.drawingShape = shape;
        this.commonInitShape(shape);
        this.drawLayer.add(shape);
        this.selectShape(shape);
      });
    },

    dragDrawing() {
      let pos = this.stage.getPointerPosition();
      let absolutePosition = this.stage.absolutePosition();
      let pointerPosition = [
        pos.x - absolutePosition.x,
        pos.y - absolutePosition.y
      ];

      switch (this.action) {
        case constants.DETAIL_DOCS_PAGE.ACTION.ADD_IMAGE:
          if (this.drawingShape) {
            if (this.shapeOptions.fixedWidth) {
              let scale =
                (this.shapeOptions.fixedWidth * this.scale) /
                this.drawingShape.width();
              let x =
                pointerPosition[0] - (this.drawingShape.width() * scale) / 2;
              let y =
                pointerPosition[1] - (this.drawingShape.height() * scale) / 2;
              this.drawingShape.setAttrs({
                x: x,
                y: y,
                scaleX: scale,
                scaleY: scale
              });
            } else {
              let scale =
                (pointerPosition[0] - this.startPointerPosition[0]) /
                this.drawingShape.width();
              this.drawingShape.scale({x: scale, y: scale});
            }
          }
          break;
        default:
          break;
      }
      this.drawLayer.draw();
      this.stage.draw();
    },

    commonInitShape(shape) {
      shape.on("mousedown", event => {
        if (this.isDrawing) return;

        let target = event.target;
        if (target.getParent() instanceof Konva.Group) {
          target = target.getParent();
        }

        if (shape === target) {
          this.selectShape(target);
        }
      });
    },

    initForShapeText(textNode, shapeOptions) {
      if (shapeOptions.addWhiteBackground) {
        //add white background
        let textNodePosition = textNode.absolutePosition();
        let textBackgroundShape = new Konva.Rect({
          id: uuidv4(),
          x: textNodePosition.x - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
          y: textNodePosition.y - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
          width: textNode.width() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2,
          height:
            textNode.height() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2,
          fill: "white"
        });
        this.drawLayer.add(textBackgroundShape);
        this.textNodeBackgroundShapeRelations.push({
          textNodeId: textNode.id(),
          textBackgroundShapeId: textBackgroundShape.id()
        });
      }
    },

    initActionForShapeText(textNode, options) {
      textNode.on("transform", () => {
        //resize text node;
        textNode.setAttrs({
          width: textNode.width() * textNode.scaleX(),
          scaleX: 1
        });
        //
        this.redrawTextNodeShapeBackgroundShape(textNode);
      });

      textNode.on("dragmove", event => {
        if (event.target === textNode) {
          this.redrawTextNodeShapeBackgroundShape(textNode);
        }
      });

      textNode.on("dblclick", event => {
        if (options.editable && event.target === textNode) {
          let text = textNode.text();
          this.isOpenEditPhuLucDialog = true;
          this.$nextTick(() => {
            this.$refs.editPhuLucDialog.setValue(text);
            this.$refs.editPhuLucDialog.$on("valueChanged", event => {
              this.isOpenEditPhuLucDialog = false;
              textNode.text(event.value);
              this.drawLayer.draw();
            });
          });
        }
      });
    },

    redrawTextNodeShapeBackgroundShape(textNode) {
      let textNodeId = textNode.id();
      let textNodeBackgroundShapeRelations = h.find(
        this.textNodeBackgroundShapeRelations,
        item => item.textNodeId === textNodeId
      );
      let textNodeBackgroundShapeId = textNodeBackgroundShapeRelations
        ? textNodeBackgroundShapeRelations.textBackgroundShapeId
        : null;
      if (textNodeBackgroundShapeId) {
        let textBackgroundShape = this.drawLayer.find(
          "#" + textNodeBackgroundShapeId
        )[0];
        if (textBackgroundShape) {
          let textNodePosition = textNode.absolutePosition();
          textBackgroundShape.absolutePosition({
            x: textNodePosition.x - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN,
            y: textNodePosition.y - constants.DETAIL_DOCS_PAGE.TEXT_MARGIN
          });
          textBackgroundShape.width(
            textNode.width() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2
          );
          textBackgroundShape.height(
            textNode.height() + constants.DETAIL_DOCS_PAGE.TEXT_MARGIN * 2
          );
        }
      }
    },

    selectShape(shape) {
      if (this.selectedShape === shape) return;
      if (this.selectedShape) this.removeTransformer_();
      this.selectedShape = shape;
      switch (shape.getClassName()) {
        case "Image":
          this.transformer = new Konva.Transformer({
            anchorStroke: "red",
            anchorFill: "red",
            anchorSize: 5,
            borderStroke: "red",
            borderDash: [5, 5],
            padding: 0,
            enabledAnchors: [
              "top-left",
              "top-right",
              "bottom-left",
              "bottom-right",
              "middle-right",
              "middle-left"
            ],
            rotateEnabled: false,
            boundBoxFunc: (oldBoundBox, newBoundBox) => {
              if (Math.abs(newBoundBox.width) < 50) {
                return oldBoundBox;
              }
              return newBoundBox;
            }
          });
          break;
        case "Group":
          this.transformer = new Konva.Transformer({
            anchorStroke: "red",
            anchorFill: "red",
            anchorSize: 5,
            borderStroke: "red",
            borderDash: [5, 5],
            padding: 0,
            enabledAnchors: [
              "top-left",
              "top-right",
              "bottom-left",
              "bottom-right",
              "middle-right",
              "middle-left"
            ],
            rotateEnabled: false,
            boundBoxFunc: (oldBoundBox, newBoundBox) => {
              if (Math.abs(newBoundBox.width) < 60) {
                return oldBoundBox;
              }
              return newBoundBox;
            }
          });
          break;
        default:
          this.transformer = new Konva.Transformer({
            anchorStroke: "red",
            anchorFill: "red",
            anchorSize: 5,
            borderStroke: "red",
            borderDash: [5, 5],
            padding: 0,
            enabledAnchors: ["middle-right", "middle-left"],
            rotateEnabled: false,
            boundBoxFunc: (oldBoundBox, newBoundBox) => {
              if (Math.abs(newBoundBox.width) < 50) {
                return oldBoundBox;
              }
              return newBoundBox;
            }
          });
          break;
      }
      this.transformer.attachTo(shape);
      this.drawLayer.add(this.transformer);
      this.drawLayer.draw();
    },

    endDrawing() {
      this.setDraggableForAllShapes(true);
      this.action = null;
      this.drawingShape = null;
    },

    drawShapeText(options) {
      let scale =
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_96_PPI /
        (constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI * this.scale);
      let shapeText = new Konva.Text({
        id: uuidv4(),
        text: options && options.text ? options.text : "",
        x: this.nonNull(options.x) ? options.x : this.startPointerPosition[0],
        y: this.nonNull(options.y) ? options.y : this.startPointerPosition[1],
        width: options.width,
        height: options.height,
        fontSize: Math.round(
          (options.fontSize ||
            constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_SIZE) / scale
        ),
        fontStyle:
          options.fontStyle ||
          constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_STYLE,
        fontFamily:
          options.fontFamily ||
          constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_FAMILY,
        fill: options.fill,
        draggable: options.draggable ? true : options.draggable,
        padding: constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.TEXT_PADDING,
        align: "center"
      });

      return shapeText;
    },

    drawShapeImage(options) {
      return new Promise(resolve => {
        const applyAttributes = (image, width, height) => {
          let scale = options.fixedWidth
            ? (options.fixedWidth * this.scale) / width
            : options.defaultWidth
              ? (options.defaultWidth * this.scale) / width
              : 1;

          image.setAttrs({
            id: uuidv4(),
            x: options.x || this.startPointerPosition[0],
            y: options.y || this.startPointerPosition[1],
            width: options.imageWidth || options.width || width,
            height: options.imageHeight || options.height || height,
            scaleX: scale,
            scaleY: scale,
            draggable: options.draggable || false
          });

          resolve(image);
        };

        if (options.url.startsWith('data:image')) {
          // Xử lý base64
          const img = new Image();
          img.onload = () => applyAttributes(new Konva.Image({ image: img }), img.width, img.height);
          img.src = options.url;
        } else {
          // Xử lý URL thông thường
          Konva.Image.fromURL(options.url, image => applyAttributes(image, image.width(), image.height()));
        }
      });
    },

    nonNull(x) {
      return x !== null && x !== undefined;
    },

    loadPage(options) {
      if (this.isDrawing) this.endDrawing();
      this.drawLayer.destroyChildren();
      this.backgroundLayer.destroyChildren();
      this.backgroundURL = options.backgroundURL;
      return this.loadBackground()
        .then(() => this.initState(options.pageData))
        .then(() => {
          this.stage.draw();
        });
    },

    findShapeOptionsByShapeId(shapeId) {
      let shapeOptionsDataItem = h.find(
        this.shapeOptionsData,
        item => item.shapeId === shapeId
      );
      return shapeOptionsDataItem ? shapeOptionsDataItem.shapeOptions : null;
    },

    removeShapeOptionsByShapeId(shapeId) {
      let indexOf = h.indexOf(
        this.shapeOptionsData,
        item => item.shapeId === shapeId
      );
      if (indexOf !== -1) this.shapeOptionsData.splice(indexOf, 1);
    },

    initState(pageData) {
      if (pageData) {
        this.textNodeBackgroundShapeRelations =
          pageData.textNodeBackgroundShapeRelations || [];
        this.shapeOptionsData = pageData.shapeOptionsData || [];
        let stage = pageData.stage;
        if (stage && stage.children && stage.children.length) {
          let drawLayerState = h.find(
            stage.children,
            child =>
              child.attrs.name === constants.DETAIL_DOCS_PAGE.DRAW_LAYER_NAME
          );
          if (drawLayerState) {
            return Promise.all(
              h.collect(drawLayerState.children, shapeState => {
                let shape;
                let shapeOptions = this.findShapeOptionsByShapeId(
                  shapeState.attrs.id
                );
                let promise;
                switch (shapeState.className) {
                  case "Text":
                    shape = new Konva.Text(shapeState.attrs);
                    this.initActionForShapeText(shape, shapeOptions);
                    this.commonInitShape(shape);
                    promise = Promise.resolve(shape);
                    break;
                  case "Image":
                    promise = this.drawShapeImage(shapeOptions).then(image => {
                      image.setAttrs(shapeState.attrs);
                      this.commonInitShape(image);
                      return image;
                    });
                    break;
                  case "Rect":
                    shape = new Konva.Rect(shapeState.attrs);
                    promise = Promise.resolve(shape);
                    break;
                }
                return promise;
              })
            ).then(shapes => {
              h.each(shapes, shape => this.drawLayer.add(shape));
              this.drawLayer.draw();
            });
          }
        }
      }
      return Promise.resolve();
    },

    loadBackground() {
      return new Promise(resolve => {
        Konva.Image.fromURL(this.backgroundURL, image => {
          // this.scale = this.$refs.canvasContainer.clientWidth / image.width();
          this.scale =
            constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_96_PPI / image.width();
          image.setAttrs({
            x: 0,
            y: 0,
            scaleX: this.scale,
            scaleY: this.scale
          });
          this.stage.width(image.width() * this.scale);
          this.stage.height(image.height() * this.scale);
          this.backgroundImage = image;
          this.backgroundLayer.add(image);
          this.backgroundLayer.draw();
          resolve();
        });
      });
    },

    addText(options) {
      if (this.isDrawing) this.endDrawing();
      this.action = constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT;
      this.shapeOptions = {
        text: options.text,
        fill: options.fill,
        editable: options.editable,
        shapeType: options.shapeType,
        defaultWidth: options.defaultWidth,
        fontSize: options.fontSize,
        fontStyle: options.fontStyle,
        addWhiteBackground: options.addWhiteBackground
      };
      this.removeTransformer();
    },

    addImage(options) {
      if (this.isDrawing) this.endDrawing();
      this.action = constants.DETAIL_DOCS_PAGE.ACTION.ADD_IMAGE;
      this.shapeOptions = {
        url: options.url,
        fixedWidth: options.fixedWidth,
        fixedHeight: options.fixedHeight,
        shapeType: options.shapeType,
        defaultWidth: options.defaultWidth,
        imageWidth: options.imageWidth,
        imageHeight: options.imageHeight
      };
      this.removeTransformer();
    },

    addTextAndImage(options) {
      if (this.isDrawing) this.endDrawing();
      this.action = constants.DETAIL_DOCS_PAGE.ACTION.ADD_TEXT_AND_IMAGE;

      let fullNameShape = {
        text: options.fullName,
        defaultWidth: options.fullNameDefaultWidth,
        fill: options.fullNameFill,
        fontStyle: options.fullNameFontStyle,
        fontSize: options.fullNameFontSize,
        width: options.fullNameWidth,
        height: options.fullNameHeight,
        shapeType: constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.PUBLISHER_INFO,
      };
      let signDateShape = {
        text: options.signDate,
        defaultWidth: options.signDateDefaultWidth,
        fontSize: options.signDateFontSize,
        width: options.signDateWidth,
        height: options.signDateHeight,
        shapeType: constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.SIGN_DATE
      };
      let imageShape = {
        url: options.url,
        defaultWidth: options.imageDefaultWidth,
        width: options.imageWidth,
        height: options.imageHeight,
        shapeType: options.imageShapeType,
      };

      switch (options.shapeType) {
        case constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.TEXT_WITH_BACKGROUND:
          fullNameShape.x = options.imageWidth / 5;
          fullNameShape.y = options.imageHeight / 3;

          signDateShape.x = options.imageWidth / 5;
          signDateShape.y = options.imageHeight / 3 + options.fullNameHeight;

          imageShape.x = 0
          imageShape.y = 0
          break;
        case constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.TEXT_WITH_LOGO_TOP:
          fullNameShape.x = 0;
          fullNameShape.y = options.imageHeight;

          signDateShape.x = 0;
          signDateShape.y = options.imageHeight + options.fullNameHeight;

          imageShape.x = (options.fullNameWidth - options.imageWidth) / 2
          imageShape.y = 0
          break;
        case constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.TEXT_WITH_LOGO_LEFT:
          fullNameShape.x = options.imageWidth - 90;
          fullNameShape.y = options.imageHeight / 4;

          signDateShape.x = options.imageWidth - 90;
          signDateShape.y = options.imageHeight / 4 + options.fullNameHeight;

          imageShape.x = 0
          imageShape.y = 0
          break;
        default:
          fullNameShape.x = options.imageWidth / 4;
          fullNameShape.y = options.imageHeight / 3;

          signDateShape.x = options.imageWidth / 4;
          signDateShape.y = options.imageHeight / 3 + options.fullNameHeight;

          imageShape.x = 0
          imageShape.y = 0
          break;
      }

      this.shapeOptions = {
        fullNameShape,
        signDateShape,
        imageShape,
        shapeType: options.shapeType
      };
      this.removeTransformer();
    },

    removeTransformer_() {
      if (this.transformer) {
        this.transformer.destroy();
        this.transformer = null;
        this.selectedShape = null;
      }
    },

    removeTransformer() {
      if (this.transformer) {
        this.removeTransformer_();
        this.stage.draw();
      }
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/detail-docs-v2.vue